export enum RoutesEnum {
  HOME = '',
  BLOG = 'blog',
  CONTACT = 'contact',
  OFFERS = 'offres',
  LANDINGS = 'agence-digitale',
  CLIENTS = 'references',
  EXPERTISES = 'expertises',
  TECHNOS = 'techno',
}
